import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ShapeInteface } from "@WhiteCap/Utils/ValueAndTotalCalculate";


type HandlerType = CustomApiHandler<{shapes: ShapeInteface[]}>

export const LoadShapeCalculation: HandlerType = props => {
	props.dispatch({
		type: "Custom/ConcreteQuote/LoadShapeCalcuation",
        shapes: props.parameter.shapes
	});
};

export const chain = [LoadShapeCalculation];

const loadConcreteShape = createHandlerChainRunner(chain, "loadConcreteShape");
export default loadConcreteShape;